import type { SidebarEntry, SidebarMenuItem, SidebarSectionEntry } from './types';

function matchesPattern(pathname: string, pattern: string) {
  if (pattern.endsWith('*')) {
    return pathname.startsWith(pattern.slice(0, -1));
  }

  return pathname === pattern;
}

export function isMenuItemActive(item: SidebarMenuItem, pathname: string) {
  const patterns = item.activePatterns?.length ? item.activePatterns : [item.to];

  return patterns.some((pattern) => matchesPattern(pathname, pattern));
}

export function isSectionActive(section: SidebarSectionEntry, pathname: string) {
  return section.items.some((item) => isMenuItemActive(item, pathname));
}

export function isSidebarEntryActive(entry: SidebarEntry, pathname: string) {
  if (entry.type === 'link') {
    return isMenuItemActive(entry, pathname);
  }

  return isSectionActive(entry, pathname);
}

export function getInitiallyOpenSections(entries: SidebarEntry[], pathname: string) {
  return entries.reduce<Record<string, boolean>>((state, entry) => {
    if (entry.type === 'section') {
      state[entry.id] = isSectionActive(entry, pathname);
    }

    return state;
  }, {});
}

export function openActiveSections(
  currentState: Record<string, boolean>,
  entries: SidebarEntry[],
  pathname: string,
) {
  const nextState = { ...currentState };

  entries.forEach((entry) => {
    if (entry.type === 'section' && isSectionActive(entry, pathname)) {
      nextState[entry.id] = true;
    }
  });

  return nextState;
}
